import React from 'react';
import { Sidebar, useUserinfo } from '@mss/mss-component-library';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faProjectDiagram,
  faUserFriends,
  faSlidersH,
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { HardDrive } from 'react-feather';

export default function EditSidebar({
  superAdminGroup,
}: {
  superAdminGroup: boolean;
}) {
  const [t] = useTranslation(['authorization', 'common']);
  const [hasPermission] = useUserinfo();
  return (
    <Sidebar>
      {hasPermission(['view_group', 'change_group']) && (
        <Sidebar.Item
          title={t('Group Settings')}
          data-ta="GroupSettingsSidebar"
          icon={<FontAwesomeIcon icon={faSlidersH} size={'sm'} />}
          url="settings"
        />
      )}
      {hasPermission(['add_usergroup', 'view_user']) && (
        <Sidebar.Item
          title={t('Members')}
          data-ta="MembersSidebar"
          icon={<FontAwesomeIcon icon={faUserFriends} size={'sm'} />}
          url="members"
        />
      )}
      {hasPermission(['change_grouppermission', 'view_grouppermission']) && (
        <Sidebar.Item
          title={t('Permission')}
          data-ta="PermissionSidebar"
          icon={<FontAwesomeIcon icon={faProjectDiagram} size={'sm'} />}
          url="permissions"
        />
      )}
      {hasPermission([
        'change_groupobjectpermission',
        'view_groupobjectpermission',
      ]) &&
        !superAdminGroup && (
          <Sidebar.Item
            title={t('Object permissions')}
            data-ta="ObjectPermissionsSidebar"
            icon={<HardDrive size={14} />}
            url="objectpermissions"
          />
        )}
    </Sidebar>
  );
}
